<template>
  <v-container class="main-container">
   <v-row>
      <v-col cols="12">
        <v-card
          tile
          flat
          class="userBriefHistory"
          :class="$vuetify.theme.dark ? 'transparent ' : 'white-lighten-2'"
        >
        <partner-tabs></partner-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import PartnerTabs from '../../components/Partners/PartnerTabs.vue';
export default {
  components: {
    PartnerTabs,
  },
};
</script>
